import React, { useContext, useEffect, useState  } from 'react';
import { Helmet } from "react-helmet";
import { AccountContext, LanguageContext, WhiteLabelContext, GeolocationContext } from "ToolboxUtils/web/context/context";
import ClusterView from 'ToolboxComponents/webapp/pages/cluster-view/cluster-view';
import Loader from 'ToolboxComponents/commons/loader/loader';
import useApiChuchoteurs from 'ToolboxUtils/web/hooks/use-api-chuchoteurs';
import useIsContentLoaded from 'ToolboxUtils/web/hooks/use-is-content-loaded';
import apiChuchoteurs from 'ToolboxUtils/web/api/api-chuchoteurs';
import getMetaDescription from 'ToolboxUtils/web/get-meta-description';
import slugify from 'url-slug';


const Cluster = props => {
  const [language] = useContext(LanguageContext).usePath();
  const [whiteLabel] = useContext(WhiteLabelContext).usePath();
  const [coordinates] = useContext(GeolocationContext).usePath('coordinates');
  const [account, setAccount] = useContext(AccountContext).usePath();

  const cluster = useApiChuchoteurs.get(`/products/${props.match.params.id}`, {
    params: { 
      filter: 'circuit', 
      language: language, 
      latitude: coordinates.latitude,
      longitude: coordinates.longitude,
      whiteLabelId: whiteLabel.id,
    }
  });

  const stops =  useApiChuchoteurs.get(`/products/${props.match.params.id}`, {
    params: { 
      filter: 'stops',
      language: language,
      latitude: coordinates.latitude,
      longitude: coordinates.longitude,
      whiteLabelId: whiteLabel.id
    }
  });

  useIsContentLoaded(cluster.isComplete && stops.isComplete);

  const openSignInModal = status => {
    setSignIn({ opened: true });
  }

  const updateFav = id => {
    if (account.favorites.includes(id)) {
      const favorites = account.favorites.filter(favorite => favorite !== id);
      setAccount('favorites', favorites);
    } else {
      const favorites = account.favorites.concat([id]);
      setAccount('favorites', favorites);
    }
  }

  return (
    <>
      {cluster.isComplete && stops.isComplete
        ? 
        <>
        <Helmet>
          <title>{cluster.data.title} - {whiteLabel.name}</title>
          <meta name="description" content={getMetaDescription(cluster.data.teaser)}/>
          <link rel="canonical" href={'https://' + window.location.hostname + (whiteLabel.path ? '/' + whiteLabel.path : '') + props.page.path[language] + `/${cluster.data.id}/${slugify(cluster.data.title, {lower: true})}`} />
        </Helmet>
        <ClusterView
            cluster={cluster.data}
            products={stops.data}
            addFavorite={async (id) => {
              if (account && account.id) {
                try {
                  const favorite = await apiChuchoteurs.post(`/accounts/${account.id}/products/${id}/favorites`, {
                    token: localStorage.token
                  })
                  updateFav(id);
                } catch(err) {
                  console.log(err);
                }
              } else {
                openSignInModal(true);
              }
            }}
            deleteFavorite={async (id) => {
              if (account && account.id) {
                try {
                  const favorite = await apiChuchoteurs.delete(`/accounts/${account.id}/products/${id}/favorites`, {
                    token: localStorage.token
                  })
                  updateFav(id);
                } catch(err) {
                  console.log(err);
                }
              } else {
                openSignInModal(true);
              }
            }} 
          />
          </>
        : <Loader />
      }
    </>
  );
}

export default Cluster;
